var Agitavit;
(function (Agitavit) {
    var Controls;
    (function (Controls) {
        var IgControlProvider = /** @class */ (function () {
            /**
             * Creates a new instance of infragistics controls provider.
             * @param editorType - The editor type.
             */
            function IgControlProvider(editorType) {
                this._editorType = editorType;
            }
            Object.defineProperty(IgControlProvider.prototype, "editor", {
                get: function () {
                    return {
                        element: this._element
                    };
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Used to initialize the editor
             * @param callbacks - list of callback methods - keyDown and textChanged
             * @param key - the key of the column to which this editor belongs
             * @param editorOptions - the editorOptions defined in the Updating feature's columnSettings for this column
             * @param tabIndex - the tabIndex of the editor
             * @param format - the format applied to the column
             * @param element - the editor's main DOM element. When creating a custom editor a new DOM element should be assigned to this argument and the element should be returned as the result of the method.
             */
            IgControlProvider.prototype.createEditor = function (callbacks, key, editorOptions, tabIndex, format, element) {
                var editor = eval(this._editorType);
                this._element = element || $("<div></div>");
                this._editor = new editor(this._element[0], editorOptions.data, editorOptions.state, null, true);
                this._element.data("agControl", this._editor);
                // tODO: find better solution when dealing with dropdown in inline grid
                // this._editor.onChange.subscribe(callbacks.textChanged);
                return this._element;
            };
            /**
             * used to attach igvalidator error events
             * @param errorShowing
             * @param errorShown
             * @param errorHidden
             */
            IgControlProvider.prototype.attachErrorEvents = function (errorShowing, errorShown, errorHidden) { };
            /**
             * gets editor instance
             */
            IgControlProvider.prototype.getEditor = function () {
                debugger;
            };
            /**
             * refreshes value - used in cases like MaskEditors where the value needs to be proccessed before being applied.
             */
            IgControlProvider.prototype.refreshValue = function () { };
            /**
             * gets value from editor. Updating uses this method to pass the current editor value as the new value for the cell when you exit edit mode for the cell.
             */
            IgControlProvider.prototype.getValue = function () {
                // endEdit on numeric and date editors
                // wraped in try/catch since document.activeElement can fail in IE (if active element is in iframe, and some other cases)
                try {
                    if (this._element[0].contains(document.activeElement) &&
                        document.activeElement.classList.contains("ui-igedit-input")) {
                        if (this._element.find("input[id]").data("igDatePicker")) {
                            this._editor.setValue(document.activeElement.value == (Agitavit.Utilities.localizeResourceKey("ig_regional_datePattern")).replace(/[a-zA-Z]/g, "_") ? null : this._element.find("input[id]").data("igDatePicker")._valueFromText(document.activeElement.value).toISOString());
                        }
                        if (this._element.find("input[id]").data("igNumericEditor")) {
                            this._editor.setValue(this._element.find("input[id]").data("igNumericEditor")
                                ._valueFromText(document.activeElement.value));
                        }
                    }
                }
                catch (ex) { }
                return this._editor.getValue();
            };
            /**
             * sets value to the editor. Updating uses this method to set the current cell value from the cell to the editor when you enter edit mode for a cell.
             * @param val
             */
            IgControlProvider.prototype.setValue = function (val) {
                this._editor.setValue(val);
            };
            /**
             * sets current size(width and height) for the editor
             * @param width
             * @param height
             */
            IgControlProvider.prototype.setSize = function (width, height) {
                this._element[0].style.width = "" + (width - 3) + "px";
                this._element[0].style.maxWidth = "" + (width - 3) + "px";
                this._element[0].style.height = "" + height + "px";
                this._element[0].style.maxHeight = "" + height + "px";
            };
            /**
             * sets focus to the editor
             */
            IgControlProvider.prototype.setFocus = function () {
                $(this._element).find("input:visible,textarea:visible").focus();
            };
            /**
             * used to detach the editor from the current parent cell element.
             */
            IgControlProvider.prototype.removeFromParent = function () { };
            /**
             * destroys the editor.
             * If there are any additional DOM elements or event handles associated with the editor they should also be removed.
             */
            IgControlProvider.prototype.destroy = function () {
                this._element.remove();
            };
            /**
             * If a validator (igValitor) should be used to validate the editor value, this method should return it. Otherwise return null.
             */
            IgControlProvider.prototype.validator = function () {
                return null;
            };
            /**
             * Triggered when validation is required. Should return the result from isValid method for the validator (if there is a validator), otherwise return true.
             * @param noLabel
             */
            IgControlProvider.prototype.validate = function (noLabel) {
                return this.isValid();
            };
            /**
             * returns if the validation is successful or not. If value is valid it should return true, otherwise it should return false.
             */
            IgControlProvider.prototype.isValid = function () {
                // re-apply value first (required for IG controls which do not save before loosing focus)
                // tODO: Currently without optimization - with it validation error was not translated on save click
                // if (document.activeElement && this._element[0].contains(document.activeElement)) {
                if (this._element.find(".input-validation-error").data("bs.tooltip")) {
                    this._element.find(".input-validation-error").tooltip("destroy");
                }
                this.setValue(this.getValue());
                Controls.Utilities.parseFormValidationRulesImpl(this._element.closest("form"));
                // }
                // validate
                return !$.contains(document.body, this._element[0]) || $(this._element).find("input,textarea").valid();
            };
            IgControlProvider.prototype.requestValidate = function () {
                return true;
            };
            /**
             * keydown handler is required for every editor
             * Should notify Updating that a key has been pressed, so that DOM elements (like the Done/Cancel buttons) can be updated accordingly.
             * @param evt
             */
            IgControlProvider.prototype.keyDown = function (evt) { };
            return IgControlProvider;
        }());
        Controls.IgControlProvider = IgControlProvider;
    })(Controls = Agitavit.Controls || (Agitavit.Controls = {}));
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=IgControlProvider.js.map